import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setRegPage, currentWidget, setDeviceConfigFailed, setFailScreen } from '../../../action/action'
import { getItemType, changePage, selectedStoreItemType, setDefaultSubTypeList, setTotalOrderPrice, setHCommerceSavedOrders, setItemTypeList } from '../../../action/hcommerce'
import { CLICKED, CMSPath, EXIT } from '../../../config/constant'
import StoreLevel1 from './storeLevel1'
import StoreLevel2 from './storeLevel2'
import ItemInfo from './itemInfo'
import MyOrder from './myOrder'
import $ from 'jquery'
import PlaceOrderNew from './placeOrderNew';
import AdditionalDetails from './additionalDetails';
import { totalPriceCal } from '../../JS/totalPriceCal'
import { calculateTimeDifference, getDefaultAnalyticsLabel } from '../../JS/utility'
import { guestDetails, sendAnalytics } from "../../../action/homeAction"
import GuestLoginPage from '../guestLoginFlow/guestLoginPage'
import LoginRequiredOverlay from '../../UI/loginRequiredOverlay'
import { setCustomTextForLoginPopup, setGoHome, setLoginRequired } from '../../action/homeAction'
import { wipeGuestData } from '../../../JS/wipeGuestData'
import { setMapOpened } from '../../action/hCommerce2'
import { scrollToTop } from '../../../JS/scrollToTop'

class HCommerce2 extends Component {

    constructor(props){
        super(props);
        
        this.defaultMinHeight = null;
        this.mapOpened = new URLSearchParams(this.props.location.search).get("mapOpened")
        this.mapWasOpened = new URLSearchParams(this.props.location.search).get("mapWasOpened")
        this.state = {
            openAdditionalDetail:false,
            widgetLaunchTime: new Date,
            widgetName: this.props.currentWidgets.widgetType
        }
    }

    storeSavedOrdersToRedux = () => {
        let savedOrders = localStorage.getItem("savedOrders");
        if (savedOrders && savedOrders !== "null") {
            savedOrders = JSON.parse(savedOrders);
        } else {
            savedOrders = []
        }

        this.props.setHCommerceSavedOrders(savedOrders);
    }

    componentDidMount() {
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let room = localStorage.getItem("room");
        scrollToTop();
        console.log("h-commerce widget: ", room, SessionToken);
        this.props.guestDetails(SessionToken, wipeGuestData, this.props.guestDetail.guestToken);
        if (SessionToken && (!this.props.guestDetail.locationId || !this.props.guestDetail.guestToken)) {
            console.log("h-commerce widget: no session token", this.props.guestDetail.locationId, this.props.guestDetail.guestToken);
            if (this.props.currentWidgets.widgetType && (!room || room === "null")) {
                // this.props.setRegPage(true);
                // return

                this.props.setCustomTextForLoginPopup({
                    topHeading:"In Room Dining",
                    warning:"In order to dine in your room, you must be checked into the hotel.",
                    heading:"Get access to In Room Dining",
                    subHeading:"Connect to the chamber and all its features by entering your last name and room number.",
                    primaryButtonText:"Connect",
                    
                })
                return ;
                
                if(process.env.REACT_APP_INROOMTAB == "true") {
                    this.props.setLoginRequired(true)
                } 
                return
                console.log("room", room);
            } else {
                console.log("there is some bug in guest registration flow.")
            }
        }else if(!navigator.onLine){
            // this.props.setDeviceConfigFailed(true);
            this.props.setFailScreen(true, "Failed to get the data", "We are not not able to get the data for service request, please check your internet connection or try again", true)
            this.props.setGoHome(true);
        }
        this.defaultMinHeight = $('body').css("min-height");
        $('body').css("min-height","100vh");

        this.props.setTotalOrderPrice(totalPriceCal());
        this.storeSavedOrdersToRedux();

        // Send Analytics
        console.log("this.props.mapOpened",this.props.mapOpened);
        if(!this.props.mapOpened){
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.props.currentWidgets.widgetType, 
                CLICKED, 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", storeName: this.props.storeInfo.storeName, pageName: this.getPageName()}, 
                0, 
                this.props.guestIsLoggedIn
            );
        } else {
            this.props.setMapOpened(false)
        }
        //
       
    }

    componentWillUnmount() {
        // this.props.currentWidget({});
        this.props.selectedStoreItemType({});
        // this.props.setDefaultSubTypeList([])
        $('body').css("min-height",this.defaultMinHeight);
        $('body').css("transform","none");
        $("body").removeClass("overlay-cast");

        // Send Analytics
            let widgetCloseTime = new Date

            let duration = calculateTimeDifference(this.state.widgetLaunchTime, widgetCloseTime, 'second');
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            console.log("this.props.mapOpened",this.props.mapOpened);
            if(!this.props.mapOpened){
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.state.widgetName, 
                EXIT, 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration, storeName: this.props.storeInfo.storeName, pageName: this.getPageName()}, 
                0, 
                this.props.guestIsLoggedIn
            );
            }
        //

    }

    getPage = () => {
        console.log("this.props.currentPage", this.props.currentPage)
        switch (this.props.currentPage) {
            case "StoreLevel1":
                return < StoreLevel1 />
            case "StoreLevel2":
                return < StoreLevel2 />
            case "itemInfo":
                return < ItemInfo />
            // case "myOrder":
            //     return < MyOrder />
            default:
                return < StoreLevel1 />
        }
    }

    getPageName = () => {
        switch (this.props.currentPage) {
            case "StoreLevel1":
                return "STORE LEVEL - 1"
            case "StoreLevel2":
                return "STORE LEVEL - 2"
            case "itemInfo":
                return "STORE ITEM DETAIL"
            // case "myOrder":
            //     return < MyOrder />
            default:
                return "STORE LEVEL - 1"
        }
    }
    render() {
        console.log('this.state.openAdditionalDetail',this.state.openAdditionalDetail, this.props.showPlaceOrder)
        return (
            <>
                {this.props.showPlaceOrder ? <PlaceOrderNew pageName={this.getPageName()}/>
                :<div>
                    {this.getPage()}
                    { this.props.hCommerceSavedOrders.length > 0 && !this.state.openAdditionalDetail &&  !this.props.storeInfo.disableAddRemoveItemsButtons &&
                        <MyOrder mapOpened = {this.mapOpened} openAdditionalDetail={()=> this.setState({openAdditionalDetail:true})}/> 
                    }
                    {/* { this.state.openAdditionalDetail && <AdditionalDetails openAdditionalDetail={(bool) => this.setState({openAdditionalDetail: bool})}/>} */}
                </div> }
                {
                    this.props.showGuestLogin && <GuestLoginPage hideFooter={true} />
                }
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        currentWidgets: state.store.sideNavBar.currentWidget,
        itemTypeList: state.store.Hcommerce.itemTypeList,
        currentPage: state.store.Hcommerce.currentPage,
        totalPrice: state.store.Hcommerce.totalPrice,
        hCommerceSavedOrders: state.store.Hcommerce.hCommerceSavedOrders,
        showPlaceOrder: state.store2.showPlaceOrder,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        mapOpened: state.store2.mapOpened,
        storeInfo: state.store.Hcommerce.storeInfo,
        showGuestLogin: state.store.showGuestLogin
    }
}
export default connect(
    mapStateToProps,
    {
        setRegPage,
        getItemType,
        changePage,
        currentWidget,
        selectedStoreItemType,
        setDefaultSubTypeList,
        setTotalOrderPrice,
        setHCommerceSavedOrders,
        setDeviceConfigFailed,
        sendAnalytics,
        setLoginRequired,
        setItemTypeList,
        setGoHome,
        guestDetails,
        setMapOpened,
        setCustomTextForLoginPopup,
        setFailScreen
    }
)(HCommerce2);